import { useWalletModal } from '../context/WalletModalContext';
import '../styles/Hero.css';

export default function Hero() {
  const { openWallet } = useWalletModal();

  return (
    <section className="hero">
      <div className="hero-left">
        <div className="hero-content">
          <h1 className="hero-heading">
            Dev Mainnet Network: The onchain UX ecosystem
          </h1>
          <div className="hero-actions">
            <button type="button" className="btn btn-primary" onClick={openWallet}>
              Connect
            </button>
            <button type="button" className="btn btn-secondary" onClick={openWallet}>
              Synchronize
            </button>
          </div>
        </div>
      </div>

      <div className="hero-right">
        <NetworkGraphic />
      </div>
    </section>
  );
}

function NetworkGraphic() {
  return (
    <svg
      className="network-graphic"
      viewBox="0 0 480 420"
      fill="none"
      aria-hidden="true"
    >
      <g stroke="#5a5c62" strokeWidth="2">
        <line x1="240" y1="260" x2="120" y2="90" />
        <line x1="240" y1="260" x2="240" y2="70" />
        <line x1="240" y1="260" x2="360" y2="90" />
        <line x1="240" y1="260" x2="90" y2="200" />
        <line x1="240" y1="260" x2="400" y2="190" />
        <line x1="240" y1="260" x2="130" y2="360" />
        <line x1="240" y1="260" x2="330" y2="330" />
        <line x1="120" y1="90" x2="240" y2="70" />
        <line x1="240" y1="70" x2="360" y2="90" />
        <line x1="360" y1="90" x2="400" y2="190" />
        <line x1="90" y1="200" x2="120" y2="90" />
        <line x1="330" y1="330" x2="400" y2="190" />
      </g>
      <g fill="#8a8c92">
        <circle cx="240" cy="260" r="12" />
        <circle cx="120" cy="90" r="6" />
        <circle cx="240" cy="70" r="6" />
        <circle cx="360" cy="90" r="6" />
        <circle cx="90" cy="200" r="7" />
        <circle cx="400" cy="190" r="7" />
        <circle cx="130" cy="360" r="9" />
        <circle cx="330" cy="330" r="8" />
      </g>
    </svg>
  );
}